const base = "block w-full rounded-[2px] border bg-white px-4 text-base text-ink placeholder:text-stone-600/70 focus:border-ink";
const border = (err) => (err ? "border-[#9B1C1C] border-2" : "border-[#8C8275]");

const Label = ({ htmlFor, label, required, as: As = "label" }) => (
  <As {...(As === "label" ? { htmlFor } : {})} className="mb-2 block text-sm font-semibold text-ink">
    {label}{required && <span aria-hidden="true" className="text-gold-deep"> *</span>}
  </As>
);

const Err = ({ id, error }) => error ? <p id={`${id}-error`} className="mt-2 text-sm font-semibold text-[#9B1C1C]" data-testid={`${id}-error`}>{error}</p> : null;

export const TextField = ({ id, label, error, required, as = "input", onFocus, ...rest }) => {
  const El = as;
  return (
    <div>
      <Label htmlFor={id} label={label} required={required} />
      <El id={id} required={required} aria-required={required || undefined} aria-invalid={!!error} aria-describedby={error ? `${id}-error` : undefined} onFocus={onFocus} className={`${base} ${border(error)} ${as === "textarea" ? "py-3" : "h-12"}`} data-testid={`${id}-input`} {...rest} />
      <Err id={id} error={error} />
    </div>
  );
};

export const SelectField = ({ id, label, error, required, options, placeholder = true, onFocus, ...rest }) => (
  <div>
    <Label htmlFor={id} label={label} required={required} />
    <select id={id} required={required} aria-required={required || undefined} aria-invalid={!!error} aria-describedby={error ? `${id}-error` : undefined} onFocus={onFocus} className={`${base} ${border(error)} h-12`} data-testid={`${id}-select`} {...rest}>
      {placeholder && <option value="">Select an option</option>}
      {options.map((o) => <option key={o} value={o}>{o}</option>)}
    </select>
    <Err id={id} error={error} />
  </div>
);

export const RadioGroup = ({ id, name, label, error, required, options, value, onChange, onFocus }) => (
  <fieldset id={id} tabIndex={-1} aria-describedby={error ? `${id}-error` : undefined} aria-invalid={!!error} data-testid={`${id}-group`}>
    <Label as="legend" label={label} required={required} />
    <div className="flex flex-wrap gap-3">
      {options.map((o) => {
        const oid = `${id}-${o.toLowerCase().replace(/[^a-z0-9]+/g, "-")}`;
        return (
          <label key={o} htmlFor={oid} className={`inline-flex min-h-[48px] cursor-pointer items-center gap-3 rounded-[2px] border bg-white px-4 has-[:checked]:border-ink has-[:checked]:bg-ivory ${border(error)}`}>
            <input id={oid} type="radio" name={name} value={o} checked={value === o} onChange={onChange} onFocus={onFocus} required={required} className="h-5 w-5 accent-[#161310]" data-testid={`${oid}-radio`} />
            <span className="text-base">{o}</span>
          </label>
        );
      })}
    </div>
    <Err id={id} error={error} />
  </fieldset>
);
